import { render, staticRenderFns } from "./Robots.vue?vue&type=template&id=7487c8c3&scoped=true&lang=pug&"
import script from "./Robots.vue?vue&type=script&lang=js&"
export * from "./Robots.vue?vue&type=script&lang=js&"
import style0 from "./Robots.vue?vue&type=style&index=0&id=7487c8c3&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7487c8c3",
  null
  
)

export default component.exports